import { Action } from '@ngrx/store'
import * as LicenseTypesTypes from './license-types.types'
import { LicenseType } from './license-types.interface'

// Fetch LicenseType Types
export class FetchLicenseTypesRequest implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchLicenseTypesSuccess implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPES_SUCCESS
  constructor(
    public payload: LicenseType[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchLicenseTypesFailure implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPES_FAILURE
  constructor(public payload: any) {}
}

// Fetch LicenseType Type
export class FetchLicenseTypeRequest implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPE_REQUEST
  constructor(public id: number) {}
}

export class FetchLicenseTypeSuccess implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPE_SUCCESS
  constructor(public payload: LicenseType) {}
}

export class FetchLicenseTypeFailure implements Action {
  readonly type = LicenseTypesTypes.FETCH_LICENSE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Delete LicenseType Type
export class DeleteLicenseTypeRequest implements Action {
  readonly type = LicenseTypesTypes.DELETE_LICENSE_TYPE_REQUEST
  constructor(public id: number) {}
}

export class DeleteLicenseTypeSuccess implements Action {
  readonly type = LicenseTypesTypes.DELETE_LICENSE_TYPE_SUCCESS
  constructor() {}
}

export class DeleteLicenseTypeFailure implements Action {
  readonly type = LicenseTypesTypes.DELETE_LICENSE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Create LicenseType Type
export class CreateLicenseTypeRequest implements Action {
  readonly type = LicenseTypesTypes.CREATE_LICENSE_TYPE_REQUEST
  constructor(public payload) {}
}

export class CreateLicenseTypeSuccess implements Action {
  readonly type = LicenseTypesTypes.CREATE_LICENSE_TYPE_SUCCESS
  constructor() {}
}

export class CreateLicenseTypeFailure implements Action {
  readonly type = LicenseTypesTypes.CREATE_LICENSE_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Update LicenseType Type
export class UpdateLicenseTypeRequest implements Action {
  readonly type = LicenseTypesTypes.UPDATE_LICENSE_TYPE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateLicenseTypeSuccess implements Action {
  readonly type = LicenseTypesTypes.UPDATE_LICENSE_TYPE_SUCCESS
  constructor() {}
}

export class UpdateLicenseTypeFailure implements Action {
  readonly type = LicenseTypesTypes.UPDATE_LICENSE_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class FetchDefaultPrefixRequest implements Action {
  readonly type = LicenseTypesTypes.FETCH_DEFAULT_PREFIX_REQUEST
  constructor() {}
}

export class FetchDefaultPrefixSuccess implements Action {
  readonly type = LicenseTypesTypes.FETCH_DEFAULT_PREFIX_SUCCESS
  constructor(public payload: any) {}
}

export class FetchDefaultPrefixFailure implements Action {
  readonly type = LicenseTypesTypes.FETCH_DEFAULT_PREFIX_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = LicenseTypesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = LicenseTypesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateLicenseTypeRequest
  | UpdateLicenseTypeSuccess
  | UpdateLicenseTypeFailure
  | FetchLicenseTypesSuccess
  | FetchLicenseTypesFailure
  | FetchLicenseTypesRequest
  | FetchLicenseTypeSuccess
  | FetchLicenseTypeFailure
  | FetchLicenseTypeRequest
  | CreateLicenseTypeRequest
  | CreateLicenseTypeSuccess
  | CreateLicenseTypeFailure
  | DeleteLicenseTypeRequest
  | DeleteLicenseTypeSuccess
  | DeleteLicenseTypeFailure
  | SetDefaultData
  | UpdateField
  | FetchLicenseTypesRequest
  | FetchLicenseTypesSuccess
  | FetchLicenseTypesFailure
  | FetchDefaultPrefixRequest
  | FetchDefaultPrefixSuccess
  | FetchDefaultPrefixFailure
